import React from "react";
import { CgTranscript } from "react-icons/cg";
import { FaFilePdf } from "react-icons/fa6";
import { GrBlog } from "react-icons/gr";
import { MdOutlineForum } from "react-icons/md";
import { TbFileUnknown } from "react-icons/tb";

export const getIcon = (
  shortCode: string
): { alt: string; i: React.ReactNode } => {
  switch (shortCode) {
    case "R":
      return {
        alt: "Document",
        i: <FaFilePdf className="text-red-500 ml-1" size={18} />,
      };
    case "B":
      return {
        alt: "Blog",
        i: <GrBlog className="text-blue-500 ml-1" size={18} />,
      };
    case "T":
      return {
        alt: "Transcript",
        i: <CgTranscript className="text-orange-500 ml-1" size={18} />,
      };
    case "F":
      return {
        alt: "Forum",
        i: <MdOutlineForum className="text-green-500 ml-1" size={18} />,
      };
    default:
      return {
        alt: "Unidentified",
        i: <TbFileUnknown className="ml-1" size={18} />,
      };
  }
};
